import React, { Component } from 'react';
import 'css/ViewSearchBox.scss';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import * as UiActions from 'actions/UiActions';
import { isTerminal } from 'utils/UiHelper';

class ViewSearchBox extends Component {
    static defaultProps = {
        autofocus: false,
        onSearchTextHandler: () => {},
    };

    constructor(props) {
        super(props);
        this.inputRef = React.createRef();

        this.state = {
            value: props.value || '',
        };
    }

    componentDidMount() {
        document.addEventListener(
            'mousedown',
            this.handleClickOutside.bind(this)
        );
        if (
            !isTerminal() &&
            this.props.autofocus &&
            this.props.value &&
            this.props.value.length > 0
        ) {
            this.inputRef.current.focus();
        }
    }
    componentWillUnmount() {
        document.removeEventListener(
            'mousedown',
            this.handleClickOutside.bind(this)
        );
    }

    formSubmitHandler = (event) => {
        event.preventDefault();
    };
    handleClickOutside(event) {
        if (
            this.state?.value &&
            event?.target?.id !== 'search-input' &&
            event?.target?.className?.indexOf &&
            event?.target?.className?.indexOf('back-btn') < 0 &&
            event?.target?.className?.indexOf('fa-angle-left') < 0
        ) {
            setTimeout(() => {
                if (window.location?.pathname.indexOf('/kamp') < 0) {
                    this.onClickClearBtn();
                }
            }, 300);
        }
    }

    onChangeValue(key, value) {
        this.setState({ value });
        this.props.onSearchTextHandler(value || null);
    }

    onChangeVal(event) {
        const { value } = event.target;
        this.setState({ value });
        this.props.onSearchTextHandler(value || null);
    }

    onClickClearBtn() {
        this.setState({ value: '' });
        this.props.onSearchTextHandler(null);
    }

    onFocusHandler(valueHandler, event) {
        this.props.uiActions.setKeyboardPopupStatus({
            element: event.target,
            valueHandler,
        });
    }

    render() {
        const closeBtn = this.state.value ? (
            <div
                className="view-search-box-cancel-btn"
                onClick={this.onClickClearBtn.bind(this)}
            >
                <i className="fa fa-times" aria-hidden="true" />
            </div>
        ) : null;

        const terminalProps = {};

        if (isTerminal()) {
            terminalProps.onFocus = this.onFocusHandler.bind(
                this,
                this.onChangeValue.bind(this)
            );
            terminalProps.onChange = this.onChangeValue.bind(this);
        }

        return (
            <div
                className={classNames('search-input-container', {
                    'terminal-search': isTerminal(),
                })}
            >
                <form
                    onSubmit={this.formSubmitHandler}
                    className="view-search-box"
                >
                    <input
                        id="search-input"
                        autoComplete="off"
                        name="search"
                        type="text"
                        placeholder="Søg efter kampe"
                        ref={this.inputRef}
                        onChange={this.onChangeVal.bind(this)}
                        value={this.state.value}
                        {...terminalProps}
                    />
                    <i className="fa fa-search" aria-hidden="true" />
                    {closeBtn}
                </form>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewSearchBox);
